// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BulbFilledSvg from "@ant-design/icons-svg/es/asn/BulbFilled";
import AntdIcon from '../components/AntdIcon';

var BulbFilled = function BulbFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BulbFilledSvg
  }));
};

BulbFilled.displayName = 'BulbFilled';
export default React.forwardRef(BulbFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BulbFilled.js
// module id = 695
// module chunks = 0